
// import Swiper JS
import Swiper from 'swiper/bundle';

class ThumbnailSLider {
    constructor() {
        this.sliders = document.querySelectorAll('.thumbnail-slider');

        this.sliders.forEach(slider => {
            const thumbnail = slider.querySelector('.thumbnail-slider__thumbnails');
            const prev = slider.querySelector('.thumbnail-slider__nav-btn--prev');
            const next = slider.querySelector('.thumbnail-slider__nav-btn--next');

            this.initSLiderThumbnail(thumbnail)
            this.initSLider(slider, thumbnail, prev, next)
        })
    }

    // ============
    // Methods
    // =============
    
    // サムネールのイニシャル
    initSLiderThumbnail(thumbnail) {
        const singleProductSLiderThumbs = new Swiper(thumbnail, {
            slidesPerView: 4,
            spaceBetween: 20,
            loop: true,
        });
    
    }

    // スライダーのイニシャル
    initSLider(slider, thmbnail, prev, next) {
        const singleProductSLider = new Swiper(slider, {
            slidesPerView: 1,
            speed: 4000,
            spaceBetween: 20,
            grabCursor: true,
            autoplay: {
                delay: 300,
                pauseOnMouseEnter: true
            },
            thumbs: {
                swiper: thmbnail
            },
            controller: {
                control: thmbnail
            },
            loop: true,
            navigation: {
                nextEl: next,
                prevEl: prev,
            }
        });
    }

}

export default ThumbnailSLider;